<eca-browser-detector *ngIf="oldLoginPage"></eca-browser-detector>

<!-- This is an invisible div that helps take care of subscribe/unsubscribe from the loggedIn$ stream -->
<div *ngIf="loggedIn$ | async"></div>

<div fxFlex="1 0 auto" fxFlexAlign="stretch" fxLayout.xl="row" [fxLayout.lt-xl]="flexDirection$ | async" fxLayoutAlign="space-between center"
fxLayoutAlign.lt-xl="start center" class="content" *ngIf="oldLoginPage">

    <eca-login-base (submitForm)="onSubmitForm($event)" [isLoading]="isLoading" [errorMessage]="loginMessageService.errorMessage$ | async" [logo]="logo$ | async"></eca-login-base>

    <div *ngIf="productCode$ | async" fxLayout="column" fxLayoutAlign="center stretch" class="welcome-note-container" ngClass.lt-xl="small">
        <div *ngIf="attributes$ | async as attributes">

        <div class="welcome-title" *ngIf="attributes.title">
            <h2>{{attributes.title}}</h2>
        </div>

        <mat-card *ngIf="attributes.announcement" class="announcement">
            <mat-card-content>
            <mat-icon>info</mat-icon>
            <div>
                <h3 *ngIf="attributes.title">Announcements</h3>
                <h2 *ngIf="!attributes.title">Announcements</h2>
                <div [innerHTML]="attributes.announcement | sanitizeHtml"></div>
            </div>
            </mat-card-content>
        </mat-card>

        <div *ngFor="let element of elements">
            <span *ngIf="attributes[element]" [innerHTML]="attributes[element] | sanitizeHtml"></span>
        </div>

        <div *ngIf="attributes.resources" class="welcome-resources-container">
            <div>
            <h3>{{attributes.resourceTitle}}</h3>
            </div>
            <div *ngFor="let item of attributes.resources">
            <div>
                <p [innerHTML]="item.message | sanitizeHtml"></p>
            </div>
            </div>
        </div>

        <div *ngIf="attributes.links" class="welcome-links-container">
            <div>
            <h3>{{attributes.linkTitle}}</h3>
            </div>
            <div *ngFor="let link of attributes.links">
            <div>
                <span *ngIf="link.name" [innerHTML]="link.name | sanitizeHtml"></span>
                <span *ngIf="link.url">:&nbsp;
                <a href="{{link.url}}">{{link.url}}</a>
                </span>
            </div>
            </div>
        </div>

        <br>
        <div *ngFor="let logoItem of attributes.logos" fxLayout fxLayoutAlign="start center" fxLayoutGap="15px" class="logo-wrapper">
            <div>
            <div *ngIf="logoItem.url && logoItem.key && logoItem.type==='login'" class="welcome-logos">
                <a href="{{logoItem.url}}" class="img-wrapper-link">
                <img class="img-responsive" src="assets{{logoItem.key}}" alt='Sample Image'>
                </a>
            </div>
            <br>
            </div>
        </div>

        <div class="client-copyright">
            <div *ngIf="attributes.copyright" [innerHTML]="attributes.copyright | sanitizeHtml" class="tiny"></div>
        </div>

        </div>
    </div>
    <div class="ie-space-evenly-hack"></div>
</div>
